import { useClubs } from "@hooks/queries"
import { Button } from "./Button"
import { tv } from "@utils/tw"
import { useHydrating } from "eddev/routing"
import { useState } from "react"
import { useIsMobile } from "@hooks/useViewportDerived"

export const IDPBranchDropdown = ({ medium }: { medium?: boolean }) => {
  const branchLinks = useClubs()
  const [open, setOpen] = useState<boolean>(false)
  const isMobile = useIsMobile()
  const hydrating = useHydrating()

  return (
    <div className={dropdownStyles({ open })}>
      <Button
        color={isMobile && !medium ? "white" : "grey"}
        size={medium ? "medium" : "tiny"}
        icon="CARET_DOWN"
        iconStyle="right"
        onClick={() => setOpen(!open)}
      >
        Find a branch
      </Button>
      {!hydrating && branchLinks.data?.siteSettings?.themeSiteSettings?.clubs && (
        <ul>
          {branchLinks.data.siteSettings.themeSiteSettings.clubs
            .filter((club) => club?.idpStoreFinderLink)
            .map((club, i) => (
              <li key={i}>
                <Button
                  size="tiny"
                  color="white"
                  href={club?.idpStoreFinderLink!}
                  target="_blank"
                  icon="ARROW_UP_RIGHT"
                  iconStyle="right"
                >
                  {club?.name}
                </Button>
              </li>
            ))}
        </ul>
      )}
    </div>
  )
}

const dropdownStyles = tv({
  base: [
    "relative",
    "[&_button]:whitespace-nowrap",
    "[&_button_svg]:transition-transform [&_button_svg]:ease-movement [&_button_svg]:duration-300",
    "[&_ul]:absolute [&_ul]:top-full [&_ul]:left-0 [&_ul]:mt-1 [&_ul]:p-1 [&_ul]:bg-white [&_ul]:rounded-md",
    "[&_ul]:flex [&_ul]:flex-col [&_ul]:gap-1 [&_ul]:w-full [&_ul]:z-30",
    "[&_ul]:max-h-0 [&_ul]:overflow-hidden [&_ul]:opacity-0",
    "[&_ul]:transition-[max-height,box-shadow,opacity] [&_ul]:ease-movement [&_ul]:duration-300",
    "[&_ul_li]:list-none [&_ul_li]:m-0 [&_ul_li]:p-0 [&_ul_li]:border-none",
    "[&_ul_li_a]:w-full [&_ul_li_button]:w-full [&_ul_li_a]:box-border [&_ul_li_button]:box-border [&_ul_li_a]:justify-between [&_ul_li_button]:justify-between",
    "md:[&_ul]:w-auto",
  ],
  variants: {
    open: {
      true: [
        "[&_button_svg]:rotate-180",
        "[&_ul]:max-h-[500px] [&_ul]:opacity-100",
        "[&_ul]:shadow-[0px_6px_12px_0px_#22222214,0px_1px_3px_0px_#2222221A]",
      ],
    },
  },
})
